import React from 'react';
import { TeamPermission } from 'nekst-api';
import ApiTokensList from './ApiTokensList';
import AccessChecker from '../../shared/authorization/AccessChecker';
import { SettingsBreadcrumbs } from '../settingsModule';
import { Breadcrumb } from '../../shared/web/layout/Breadcrumbs';

export default function ApiTokensPage() {
  return (
    <AccessChecker permissionToCheck={TeamPermission.MANAGE_INTEGRATIONS}>
      <SettingsBreadcrumbs>
        <Breadcrumb text="API Tokens" />
      </SettingsBreadcrumbs>
      <ApiTokensList />
    </AccessChecker>

  );
}
